import { PrintersFields } from "../models/settings-printers.model";

export const ENABLED_FIELDS: (keyof PrintersFields)[] = [ 'type', 'manifacturer' ];
export const DOCUMENTS_FIELDS: (keyof PrintersFields)[] = [ 
    'print_e_invoice', 'print_fiscal_receipt', 'print_generic_document',
    'print_generic_invoice', 'print_generic_receipt', 'print_invoice',
    'print_receipt', 'print_receipt_invoice', 'print_shipping_invoice',
    'print_summary_e_nrc', 'print_summary_e_rc', 'print_summary_invoice'
];

export type VendorType = 'fiscal' | 'rt';
export interface Vendor {
  name: string;
  value: string;
}

export const VENDORS:  Record<VendorType, Vendor[]> = {
    fiscal: [{
        name: "RCH",
        value: "rch"
    }],
    rt: [{
        name: "RCH",
        value: "rch"
    },{
        name: "Epson",
        value: "epson"
    },{
        name: "Custom / Italretail",
        value: "custom"
    },{
        name: "Axon (vecchio protocollo)",
        value: "axon"
    },{
        name: "Axon Hydra II",
        value: "axon_g100"
    },{
        name: "DTR",
        value: "dtr"
    },{
        name: "Ditron",
        value: "ditron"
    }]
};

export const PRINTER_TYPES = [{
    value: "rt",
    name: 'PRINTERS.NEW_DIALOG.RT'
},{
    value: "nonfiscal",
    name: 'PRINTERS.NEW_DIALOG.NONFISCAL'
},{
    value: "kds",
    name: 'PRINTERS.NEW_DIALOG.KDS'
},{
    value: "receipt",
    name: 'PRINTERS.NEW_DIALOG.RECEIPT'
},{
    value: "fiscal",
    name: 'PRINTERS.NEW_DIALOG.FISCAL'
}];

export const CONNECTION_TYPES = [{
    value: "escpos",
    name: 'PRINTERS.NEW.ESC_POS'
},{
    value: "epos",
    name: 'PRINTERS.NEW.EPOS'
}];

export const FISCAL_PROVIDERS = [{
    value: null,
    name: 'PRINTERS.NEW.NO_PROVIDER'
},{
    value: "retailforce",
    name: 'PRINTERS.NEW.RETAIL_FORCE'
}];


export type FiscalPrinterType = 'axon' | 'axon_g100' | 'custom' | 'dtr' | 'epson' | 'rch' | 'ditron';
export interface FiscalPrinterInfo {
  label: string;
  driver: string;
  connectionType: string;
}

export const FISCAL_PRINTER: Record<FiscalPrinterType, FiscalPrinterInfo> = {
    axon: { label: 'Axon (Vecchio protocollo)', driver: 'axon', connectionType: 'ts' },
    axon_g100: { label: 'Axon Hydra II', driver: 'axon_g100', connectionType: 'ts' },
    custom: { label: 'Custom / Italretail', driver: 'custom', connectionType: 'ts' },
    dtr: { label: 'DTR', driver: 'dtr', connectionType: 'ts' },
    epson: { label: 'Epson', driver: 'epson', connectionType: 'ws' },
    rch: { label: 'RCH', driver: 'rch', connectionType: 'ws' },
    ditron: { label: 'Ditron', driver: 'ditron', connectionType: 'ws' },
}

export const ORDER_PRINTER_DEFAULT_CONFIG = {
    "add_prices_to_order": false,
    "codepage_mapping": "epson",
    "footer_covers": -1,
    "footer_customer_info": -1,
    "footer_date": 0,
    "footer_delivery_info": -1,
    "footer_operator_name": 0,
    "footer_order_name": -1,
    "footer_order_notes": -1,
    "footer_order_number": -1,
    "footer_print_type": -1,
    "footer_printer_categories": -1,
    "footer_room_name": -1,
    "footer_table_name": -1,
    "footer_time": 16,
    "footer_total_pieces": -1,
    "footer_final_amount": -1,
    "header_covers": 16,
    "header_customer_info": 16,
    "header_date": -1,
    "header_delivery_info": 16,
    "header_operator_name": -1,
    "header_order_categories": -1,
    "header_order_name": 0,
    "header_order_notes": -1,
    "header_order_number": -1,
    "header_print_type": 16,
    "header_printer_categories": -1,
    "header_room_name": 16,
    "header_table_name": 17,
    "header_time": -1,
    "header_total_pieces": -1,
    "header_final_amount": -1,
    "item_font_size": 17,
    "item_hide_border": true,
    "item_hide_brackets": true,
    "item_spacing": 0,
    "items_align": "left",
    "items_group_by": "exit",
    "merge_same_items": false,
    "line_spacing": 0,
    "split_orders_by_exit": false,
    "variation_font_size": 16
}